import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';

@Injectable()
export class MessageService {

    //Role
    //add role success message
    public roleCreate: string = "Role added successfully";
    //edit role success message
    public roleUpdate: string = "Role has been updated";
    //delete role success message
    public roleDelete: string = "Role has been deleted";

    //Organisation
    //add Organisation success message
    public organisationCreate: string = "Organisation added successfully";
    //edit Organisation success message
    public organisationUpdate: string = "Organisation updated successfully";
    //activate Organisation success message
    public orgActivate: string = 'Organisation has been activated.';
    //deactivate Organisation success message
    public orgDeactivate: string = 'Organisation has been de-activated.';
    //address details Organisation error message
    public addDetailFail: string = 'Failed to get address detail.'
    //browser support error message
    public browserSupportFail: string = "Sorry, browser does not support geolocation!"

    //Location
    //add Location success message
    public locationCreate: string = 'Location added successfully';
    //edit Location success message
    public locationUpdate: string = 'Location updated successfully';

    //User
    //add User success message
    public userCreate: string = "User added successfully";
    //edit User success message
    public userUpdate: string = "User updated successfully";
    //activate User success message
    public userActivate: string = 'User has been activated.';
    //deactivate User success message
    public userDeactivate: string = 'User has been de-activated.';

    //Chain
    //add Chain success message
    public chainCreate: string = 'Chain initialised.';
    //activate Chain success message
    public chainActivate: string = 'Chain has been activated.';
    //deactivate Chain success message
    public chainDeactivate: string = 'Chain has been de-activated.';
    //delete chain success message
    public chainDelete: string = 'Chain has been deleted.';

    //Participant
    //add participant success message
    public participantCreate: string = 'Participant created';
    //edit participant success message
    public participantUpdate: string = 'Participant has been updated.';
    //delete participant success message
    public participantDelete: string = 'Participant has been removed.';

    //Medicine
    //add medicine success message
    public medicineCreate: string = 'Medicine added successfully';
    //edit medicine success message
    public medicineUpdate: string = 'Medicine updated successfully';

    //Batch
    //add Batch success message
    public batchCreate: string = 'Batch created successfully!';
    //add Batch Failed Error message
    public batchCreateFail: string = 'Failed to create batch';
    // edit Batch success message
    public batchUpdate: string = 'Batch updated successfully!';
    //edit Batch error message
    public batchUpdateFail: string = 'Failed to update batch';
    //recall Batch success message
    public batchRecall: string = "Batch has been updated for recall";
    //delete Batch success message
    public batchDelete: string = "Batch has been cancelled";
    //complete Batch success message
    public batchComplete: string = "Batch has been marked as completed";
    //labels email success message
    public labelsEmail: string = 'Labels have been generated and emailed.';
    //labels create errpr message
    public labelsCreateFail: string = 'Failed to create labels';
    //faild to delete packages errpr message
    public packageDeleteFail: string = 'Failed to delete Packages linked to entered batchNo';
    // bulk label success
    public bulkBatchCreate: string = 'Labels have been generated';
    //add Bulk Batch Failed Error message
    public bulkBatchCreateFail: string = 'Failed to create bulk batch labels';
    // void and reissue a single bulk api batch label
    public bulkLabelReplaced: string = 'Label has been voided and reissued';
    public bulkLabelReplaceFail: string = 'Failed to void and reissue the label';
    // batch quantity reconciliation
    public productionQtySet: string = 'Batch production quantity has been set';
    public productionQtyExceeded: string = 'Total net weight of these labels exceeds the batch production quantity';

    //packages
    //delete package success message
    public packageDelete: string = "Package has been cancelled";

    //Device
    //device  success message
    public devicesSynced: string = 'Devices synced successfully';
    public deviceDetailsUpdate: string = 'Device details are updated';
    public deviceActivate: string = 'Device has been activated!'
    public deviceDeactivate: string = 'Device has been de-activated!'
    public trackDisabled: string = 'Tracking has been turned on for the device';
    public killCommand: string = 'Kill command has been initated!'
    public deviceLinked: string = 'Device linked successfully'
    public trackingTurnedOff: string = 'Tracking has been turned off for the device'

    //Truck success message
    public truckAdded: string = "Truck added successfully!";
    public truckInactive: string = 'Truck has been marked as in-active';
    public truckActive: string = 'Truck has been marked as active';
    public truckUpdate: string = "Truck updated successfully!";

    //Segment
    //add segment success message
    public segmentCreate: string = "Segment  created";
    //edit segment success message
    public segmentUpdate: string = "Segment  updated";
    //segment userlist success message
    public segmentUserlistUpdate: string = "Segment user list updated";
    //delete segment success message
    public segmentDelete: string = "Segment  has been cancelled";
    //activate segment success message
    public segmentActivate: string = 'Segment has been activated.';
    //deactivate segment success message
    public segmentDeactivate: string = 'Segment has been de-activated.';

    //Notification
    //add notification success message
    public notificationCreate: string = 'Notification created';
    //edit notification success message
    public notificationUpdate: string = "User assigment updated";
    //delete notification success message
    public notificationDelete: string = "Notification  has been cancelled";
    //sent notification success message
    public notificationSent: string = "Notification  has been sent";

    //View/Edit Profile
    //contact Update success message
    public contactUpdate: string = 'Contact updated successfully!';
    //contact Save success message
    public contactSave: string = 'Contact saved successfully!';

    //change Password update success message
    public newPswdUpdate: string = "Your new password has been updated";
    //new Password dont match error message
    public newPswdsDontMatch: string = 'New passwords do not match. Please correct and try again';
    //new Password dont match error message
    public newDiffPswd: string = 'New password must be different from old password';

    //reset password
    public pswdsDontMatch: string = 'Passwords do not match. Please correct and try again.'

    constructor(
        private snackBar: MatSnackBar
    ) { }

    public showSuccess(msg) {
        this.snackBar.openFromComponent(SnackBarComponent, { data: { error: false, msg: msg } });
    }

    public showError(msg) {
        this.snackBar.openFromComponent(SnackBarComponent, { data: { error: true, msg: msg } });
    }

}